<div class="product-page-grid-item" [attr.title]="title">
    <a
        [attr.aria-labelledby]="'product-item-meta-' + htmlIdFromSku()"
        href="{{ getProductUrl() }}"
        (click)="onClick($event)"
        [id]="htmlIdFromSku()"
        data-cs-override-id>
        <h-image-resizer
            [desktopUrl]="crossSellingProduct.image"
            [desktopAlt]="crossSellingProduct.title"
            [mediaType]="productInGrid"
            [imageId]="crossSellingProduct.sku"
            (imageInViewPort)="handleImageInViewPort($event)">
        </h-image-resizer>

        <div
            class="product-item-meta"
            [attr.role]="'text'"
            [id]="'product-item-meta-' + htmlIdFromSku()"
            data-cs-override-id>
            <h3 class="product-item-name paragraph-small">{{ crossSellingProduct.title }}</h3>
            @if (crossSellingProduct.avgColor && !crossSellingProduct.isColorless) {
            <span class="product-item-colors" hSrOnlyNoSnippet>
                <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
                <span i18n="@@hermes-global-translations.color">Color</span>
                <ng-container i18n="@@hermes.accessibility.colon">:&nbsp;</ng-container>
                {{ crossSellingProduct.avgColor }}
            </span>
            } @if (crossSellingProduct.massVolume) {
            <div class="product-item-variants">
                <span hSrOnlyNoSnippet>
                    <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
                    <span i18n="@@hermes-global-translations.volume">Volume</span>
                    <ng-container i18n="@@hermes.accessibility.colon">:&nbsp;</ng-container>
                </span>
                {{ crossSellingProduct.massVolume }}
            </div>
            } @if (crossSellingProduct.moreColors) {
            <div class="product-item-variants">
                <span hSrOnlyNoSnippet>
                    <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
                </span>
                <span i18n="@@hermes_grid.more-colors">Other colors available</span>
            </div>
            } @if (crossSellingProduct.price) {
            <div class="product-item-price">
                <span hSrOnlyNoSnippet>
                    <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
                </span>
                <h-price [price]="crossSellingProduct.price" [size]="'small'" [format]="'short'"></h-price>
            </div>
            }
        </div>
        @if (crossSellingProduct?.personalize) {
        <h-personalize-label [persoProductType]="crossSellingProduct?.persoProductType"></h-personalize-label>
        }
    </a>
</div>
